import styled from 'styled-components';

import Icon from '/components/ui/Icon';
import decorateText from '/lib/utils/decorateText';
import Paragraph from '/components/ui/Paragraph';
import { colors } from '/css';

export default function Tip({ text }) {
    if (!text) return null;

    return (
        <Wrapper className="mb-60 pt-24 pb-24 pl-32 pr-32 bg-green-light br flex job-tip">
            <Icon
                icon="bulb"
                style={{
                    marginRight: '12px',
                    marginTop: '7px',
                    minWidth: '24px',
                }}
            />
            <Paragraph medium>{decorateText(String(text))}</Paragraph>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    a {
        color: ${colors.purple}!important;
        &:hover {
            color: ${colors.orange}!important;
        }
    }
`;
